import React from 'react';
import LoginLayout from '../components/layout/LoginLayout';
import Layout from '../components/layout/Layout';
import routes from '../configs/routes';
import { GUEST_MODULE, SYSTEM_MODULE } from '../configs/moduleNames';
import { sortLinksFunction } from './layout-utils';
import PermissionDeniedPage from '../modules/System/components/PermissionDeniedPage';

export const filterRoutes = (routesList, loggedIn, permissions = {}, state = {}, isMobile, isLoading = false) => {
  const userRoutes = [];
  const userRoutesForMenu = [...routesList].filter((route = {}) => {
    if (typeof route.permission === 'string') {
      route.permission = [route.permission];
    }
    const needLoggedIn = Boolean(loggedIn) === Boolean(route.loginRequired);
    // const isMobileUse = (route.forMobile && isMobile) || (!route.forMobile && !isMobile);
    const isGuestModule = route.permission.some(item => item === GUEST_MODULE);
    const permission = !!route.permission.every(routePermission => !!permissions[routePermission]);
    const isSystemModule = route.permission.some(item => item === SYSTEM_MODULE);
    if (permission && route.children && route.children.length && loggedIn) {
      route.children = filterRoutes(route.children, loggedIn, permissions, state, isMobile, isLoading);
    }
    let customFilter = true;
    if (route && route.filter && typeof route.filter === 'function') {
      customFilter = route.filter(state, route);
    }

    if (needLoggedIn && customFilter) { //  && isMobileUse
      if (!permission && !(isGuestModule || isSystemModule)) {
        userRoutes.push({ ...route, element: <PermissionDeniedPage /> });
      } else {
        const Component = route.component;
        userRoutes.push({ ...route, element: <Component /> });
      }
    }
    return needLoggedIn && customFilter && (permission || isGuestModule || isSystemModule); //  && isMobileUse
  });
  return isLoading ? userRoutesForMenu : userRoutes;
};

export const getRouteByRole = (loggedIn, permissions = {}, state = {}, isMobile, isLoading) => filterRoutes(routes, loggedIn, permissions, state, isMobile, isLoading);

export const calculateBaseRoute = (loggedIn, permissions = {}, state = {}, isMobile, isLoading) => {
  const currentRoutes = getRouteByRole(loggedIn, permissions, state, isMobile, isLoading);
  const sortedRoutes = currentRoutes.filter(i => !i.hideOnMenu && i.permission[0] !== 'SYSTEM').sort(sortLinksFunction);
  window.baseRoute = sortedRoutes && sortedRoutes.length ? sortedRoutes[0].path : '/';
  return window.baseRoute;
};

export const getLayoutByRole = (loggedIn, isMobile = false) => {
  if (!loggedIn) {
    return LoginLayout;
  }
  if (isMobile) {
    return Layout;
  }
  return Layout;
};
